import React, { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import NProgress from 'nprogress';

import { useAppDispatch } from 'store';

import { blokTestConst } from 'modules/blok-test';
import { isBrowser, setConfirmationModal, setRouteLoading } from 'modules/global';

import ConfirmationModal from './confirmation-modal';

export interface IProps {
  ticketId?: number;
}

const RouteChangeGuard: React.FC<IProps> = ({ ticketId }: IProps) => {
  const { events } = useRouter();
  const dispatch = useAppDispatch();
  const [nextRouterPath, setNextRouterPath] = useState<string | undefined | null>();

  const onRouteChangeStart = useCallback(
    (nextPath: string) => {
      if (!ticketId) {
        return;
      }

      if (nextPath === (isBrowser() ? window.location.pathname : '/')) {
        return;
      }

      dispatch(setConfirmationModal(true));
      setNextRouterPath(nextPath);

      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw 'cancelRouteChange';
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ticketId]
  );

  const onRejectRouteChange = () => {
    setNextRouterPath(null);
    dispatch(setConfirmationModal(false));
    dispatch(setRouteLoading(false));
    NProgress.done();
  };

  const removeListener = () => {
    events.off('routeChangeStart', onRouteChangeStart);
  };

  const onConfirmRouteChange = () => {
    if (nextRouterPath) {
      removeListener();
      dispatch(setRouteLoading(true));
      NProgress.start();
    }

    setNextRouterPath(null);
    dispatch(setConfirmationModal(false));
  };

  useEffect(() => {
    events.on('routeChangeStart', onRouteChangeStart);

    return removeListener;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onRouteChangeStart]);

  return (
    <ConfirmationModal
      testType={blokTestConst.testTypes.UNIVERSITY_TEST}
      onConfirm={onConfirmRouteChange}
      onAfterClose={onRejectRouteChange}
      ticketId={ticketId}
    />
  );
};

export default RouteChangeGuard;
